import { usePathname, useLocalSearchParams } from "expo-router";
import { View, Text } from "@src/components";
import { getWebBreadcrumbs } from "@src/utils/web-breadcrumbs";
import { NavPressable } from "@src/components/NavPressable";
import { useTenantId } from "@src/features/tenants";

export function Breadcrumbs() {
  const pathname = usePathname();
  const contextTenantId = useTenantId();
  const params = useLocalSearchParams<{
    tenantId?: string;
    siteId?: string;
    cameraKey?: string;
    userId?: string;
  }>();

  const breadcrumbs = getWebBreadcrumbs({
    pathname,
    tenantId: params.tenantId || contextTenantId || undefined,
    siteId: params.siteId,
    cameraKey: params.cameraKey,
    userId: params.userId,
  });

  return (
    <View flexDirection="row" alignItems="center" gap="md">
      {breadcrumbs.map((item, index) => (
        <View key={index} flexDirection="row" alignItems="center" gap="md">
          {index > 0 && (
            <Text textStyle="sm/regular" color="textMuted">
              /
            </Text>
          )}
          {item.href ?
            <NavPressable href={item.href as never}>
              <Text textStyle="sm/regular" color="text">
                {item.label}
              </Text>
            </NavPressable>
          : <Text textStyle="sm/bold" color="text">
              {item.label}
            </Text>
          }
        </View>
      ))}
    </View>
  );
}
